module.exports = __webpack_public_path__ + "img/bg-image-12.402b13dd.jpg";